import { Link, NavLink } from "react-router-dom";
import logo from "../assets/Logo.png";

export default function Navbar() {
  return (
    <nav
      className="text-white shadow-lg"
      style={{ backgroundColor: "#0A1A44" }} // Sapphire Blue background
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-4">
        <Link to="/">
          <img src={logo} alt="Carnatic Cafe Inc." className="h-16" />
        </Link>

        <div className="space-x-6 hidden md:block">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFD580]"
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/menu"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#C69A35]"
            }
          >
            Menu
          </NavLink>

          <NavLink
            to="/tiffin"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Tiffin
          </NavLink>

          <NavLink
            to="/catering"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Catering
          </NavLink>

          <NavLink
            to="/gallery"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Gallery
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Contact
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            About
          </NavLink>
        </div>
      </div>
    </nav>
  );
}
